import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE, getRouteMeta } from '../seo/siteConfig';

/**
 * Per-page SEO tags: title, description, canonical, Open Graph and Twitter Card.
 * Pass `pathname` (the client-side route) — meta is resolved from siteConfig.
 */
export default function Seo({ pathname = '/', image = DEFAULT_OG_IMAGE }) {
  const meta = getRouteMeta(pathname);
  const url = `${SITE_URL}${meta.path === '/' ? '' : meta.path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{meta.title}</title>
      <meta name='description' content={meta.description} />
      <link rel='canonical' href={url} />
      {meta.noindex && <meta name='robots' content='noindex, follow' />}

      {/* Open Graph */}
      <meta property='og:type' content='website' />
      <meta property='og:site_name' content={SITE_NAME} />
      <meta property='og:title' content={meta.title} />
      <meta property='og:description' content={meta.description} />
      <meta property='og:url' content={url} />
      <meta property='og:image' content={image} />
      <meta property='og:locale' content='en_CA' />

      {/* Twitter */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={meta.title} />
      <meta name='twitter:description' content={meta.description} />
      <meta name='twitter:image' content={image} />
    </Helmet>
  );
}
